(function () {
  'use strict';

  var MOBILE_MQ = window.matchMedia('(max-width: 768px)');
  var REDUCED_MOTION_MQ = window.matchMedia('(prefers-reduced-motion: reduce)');
  var MOBILE_SPEED_MULTIPLIER = 1.35;
  var TAP_MAX_MOVE = 12;
  var TAP_MAX_DURATION = 320;
  var CONTROLS_HIDE_DELAY = 4500;

  function parseNumber(value, fallback) {
    var n = parseFloat(value);
    return Number.isFinite(n) ? n : fallback;
  }

  function initGallery(root) {
    var viewport = root.querySelector('[data-nr-gallery-viewport]');
    var track = root.querySelector('[data-nr-gallery-track]');
    var controls = root.querySelector('[data-nr-gallery-controls]');
    var prevBtn = root.querySelector('[data-nr-gallery-prev]');
    var nextBtn = root.querySelector('[data-nr-gallery-next]');
    if (!viewport || !track) return;

    var baseSpeed = parseNumber(root.getAttribute('data-base-speed'), 6) / 10;
    var boostMultiplier = parseNumber(root.getAttribute('data-boost-multiplier'), 3);
    var edgeZonePercent = parseNumber(root.getAttribute('data-edge-zone'), 20);
    var resumeDelay = parseNumber(root.getAttribute('data-resume-delay'), 1000);

    var isMobile = MOBILE_MQ.matches;
    var reducedMotion = REDUCED_MOTION_MQ.matches;
    var visible = true;
    var paused = false;
    var pointerZone = 0;
    var resumeTimer = null;
    var controlsTimer = null;
    var rafId = null;
    var userScrolling = false;
    var controlsVisible = false;
    var position = 0;
    var touchStartX = 0;
    var touchStartY = 0;
    var touchStartTime = 0;
    var touchMoved = false;

    function setMode() {
      isMobile = MOBILE_MQ.matches;
      reducedMotion = REDUCED_MOTION_MQ.matches;
      root.classList.toggle('nr-footer-gallery--desktop', !isMobile && !reducedMotion);
      root.classList.toggle('nr-footer-gallery--mobile', isMobile);
      if (!isMobile) {
        hideControls(true);
      }
    }

    function getHalfWidth() {
      return track.scrollWidth / 2;
    }

    function getSlideCount() {
      var half = getHalfWidth();
      var step = getSlideStep();
      if (!step || half <= 0) return 0;
      return Math.round(half / step);
    }

    function wrapPosition() {
      var half = getHalfWidth();
      if (half <= 0) return;
      if (position >= half) {
        position -= half;
      } else if (position < 0) {
        position += half;
      }
    }

    function syncPositionFromViewport() {
      position = viewport.scrollLeft;
      wrapPosition();
    }

    function getSpeed() {
      if (paused || reducedMotion || !visible) return 0;

      var speed = baseSpeed;

      if (isMobile) {
        speed = baseSpeed * MOBILE_SPEED_MULTIPLIER;
      } else if (pointerZone !== 0) {
        speed = baseSpeed * boostMultiplier * pointerZone;
      }

      return speed;
    }

    function tick() {
      var speed = getSpeed();
      if (speed !== 0) {
        position += speed;
        wrapPosition();
        viewport.scrollLeft = position;
      }
      rafId = window.requestAnimationFrame(tick);
    }

    function beginUserScroll() {
      paused = true;
      userScrolling = true;
      if (resumeTimer) {
        window.clearTimeout(resumeTimer);
        resumeTimer = null;
      }
    }

    function scheduleResume() {
      if (!userScrolling) return;
      if (resumeTimer) window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(function () {
        if (!controlsVisible) {
          paused = false;
          userScrolling = false;
          syncPositionFromViewport();
        }
        resumeTimer = null;
      }, resumeDelay);
    }

    function getSlideStep() {
      var slide = track.querySelector('.nr-footer-gallery__slide');
      if (!slide) return 0;
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      return slide.offsetWidth + gap;
    }

    function scrollBySlide(direction) {
      var step = getSlideStep();
      var slideCount = getSlideCount();
      if (!step || !slideCount) return;

      syncPositionFromViewport();

      var index = Math.round(position / step);
      var nextIndex = index + direction;

      if (nextIndex < 0) {
        nextIndex = slideCount - 1;
      } else if (nextIndex >= slideCount) {
        nextIndex = 0;
      }

      position = nextIndex * step;
      wrapPosition();
      viewport.scrollLeft = position;
      scheduleControlsHide();
    }

    function scheduleControlsHide() {
      if (controlsTimer) window.clearTimeout(controlsTimer);
      controlsTimer = window.setTimeout(function () {
        hideControls();
        controlsTimer = null;
      }, CONTROLS_HIDE_DELAY);
    }

    function showControls() {
      if (!isMobile || controlsVisible) return;
      syncPositionFromViewport();
      controlsVisible = true;
      paused = true;
      userScrolling = true;
      root.classList.add('nr-footer-gallery--controls-visible');
      if (controls) controls.hidden = false;
      if (resumeTimer) {
        window.clearTimeout(resumeTimer);
        resumeTimer = null;
      }
      scheduleControlsHide();
    }

    function hideControls(force) {
      if (!isMobile && !force) return;
      if (!controlsVisible && !force) return;
      controlsVisible = false;
      root.classList.remove('nr-footer-gallery--controls-visible');
      if (controls) controls.hidden = true;
      if (controlsTimer) {
        window.clearTimeout(controlsTimer);
        controlsTimer = null;
      }
      if (userScrolling) {
        scheduleResume();
      } else {
        paused = false;
      }
    }

    function handleTouchStart(event) {
      if (!isMobile || !event.touches.length) return;
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
      touchStartTime = Date.now();
      touchMoved = false;
    }

    function handleTouchMove(event) {
      if (!isMobile || !event.touches.length) return;
      var dx = Math.abs(event.touches[0].clientX - touchStartX);
      var dy = Math.abs(event.touches[0].clientY - touchStartY);
      if (dx > TAP_MAX_MOVE || dy > TAP_MAX_MOVE) {
        touchMoved = true;
      }
    }

    function handleTouchEnd(event) {
      if (!isMobile) return;
      if (touchMoved) return;
      if (Date.now() - touchStartTime > TAP_MAX_DURATION) return;

      var target = event.target;
      if (target.closest('[data-nr-gallery-prev], [data-nr-gallery-next], [data-nr-gallery-controls]')) return;

      showControls();
    }

    function handleOutsidePointer(event) {
      if (!isMobile || !controlsVisible) return;
      if (root.contains(event.target)) return;
      hideControls();
    }

    function handleNavAction(event) {
      event.preventDefault();
      event.stopPropagation();

      var now = Date.now();
      if (handleNavAction.lastAt && now - handleNavAction.lastAt < 350) return;
      handleNavAction.lastAt = now;

      beginUserScroll();
      scrollBySlide(event.currentTarget === prevBtn ? -1 : 1);
    }

    function handlePointerMove(event) {
      if (isMobile || reducedMotion) return;

      var rect = viewport.getBoundingClientRect();
      var x = event.clientX - rect.left;
      var edge = rect.width * (edgeZonePercent / 100);

      if (x < edge) {
        pointerZone = -1;
      } else if (x > rect.width - edge) {
        pointerZone = 1;
      } else {
        pointerZone = 0;
      }
    }

    function handlePointerLeave() {
      pointerZone = 0;
    }

    if (prevBtn) {
      prevBtn.addEventListener('pointerup', handleNavAction);
      prevBtn.addEventListener('click', handleNavAction);
    }

    if (nextBtn) {
      nextBtn.addEventListener('pointerup', handleNavAction);
      nextBtn.addEventListener('click', handleNavAction);
    }

    viewport.addEventListener('touchstart', handleTouchStart, { passive: true });
    viewport.addEventListener('touchmove', handleTouchMove, { passive: true });
    viewport.addEventListener('touchend', handleTouchEnd, { passive: true });
    viewport.addEventListener('touchcancel', handleTouchEnd, { passive: true });

    document.addEventListener('touchstart', handleOutsidePointer, { passive: true });
    document.addEventListener('pointerdown', handleOutsidePointer);

    root.addEventListener('mousemove', handlePointerMove);
    root.addEventListener('mouseleave', handlePointerLeave);

    MOBILE_MQ.addEventListener('change', setMode);
    REDUCED_MOTION_MQ.addEventListener('change', setMode);

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          visible = entries[0] && entries[0].isIntersecting;
        },
        { root: null, threshold: 0 }
      );
      observer.observe(root);
    }

    setMode();
    if (!reducedMotion) {
      rafId = window.requestAnimationFrame(tick);
    }

    window.addEventListener(
      'pagehide',
      function () {
        if (rafId) window.cancelAnimationFrame(rafId);
        if (resumeTimer) window.clearTimeout(resumeTimer);
        if (controlsTimer) window.clearTimeout(controlsTimer);
        document.removeEventListener('touchstart', handleOutsidePointer);
        document.removeEventListener('pointerdown', handleOutsidePointer);
      },
      { once: true }
    );
  }

  function init() {
    document.querySelectorAll('[data-nr-footer-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
